import React, { forwardRef } from 'react';
import ReactSelect, { Props as BaseProps } from 'react-select';
import {
  selectBorderStyles,
  SelectSC,
  selectUnderlineStyles,
} from './select.styled';
import * as Options from './options';
import { FlattenSimpleInterpolation } from 'styled-components';
import TagSelect from './tag-select/tag-select';

type FilteredBaseProps = Omit<BaseProps, 'isMulti'>;

export interface SelectProps extends FilteredBaseProps {
  variation?: 'lined' | 'round';
  error?: boolean;
  prefix?: React.ReactNode;
  style: React.CSSProperties;
  isMulti?: boolean;
  label?: string;
  customCss?: FlattenSimpleInterpolation;
}

const Select = (
  {
    variation = 'lined',
    styles,
    style,
    label,
    alignment,
    customCss,
    ...rest
  }: SelectProps,
  ref?: React.Ref<ReactSelect>,
) => {
  const selectStyle = React.useMemo(
    () =>
      variation === 'lined'
        ? selectUnderlineStyles(styles)
        : selectBorderStyles(styles),
    [variation, styles],
  );

  return (
    <SelectSC
      style={style as React.CSSProperties}
      variation={variation}
      customCss={customCss}
    >
      {rest.prefix && rest.prefix}
      <ReactSelect
        ref={ref}
        {...rest}
        className="ui-select"
        classNamePrefix="ui-react-select"
        styles={selectStyle}
      />
    </SelectSC>
  );
};

export default forwardRef(Select);

export { Options, TagSelect };
